import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu"
export default class extends Controller {
  static targets = ["menu", "hamburgerIcon", "closeIcon", "button"]

  connect() {
    // Only initialize if all required targets exist
    if (!this.hasMenuTarget || !this.hasHamburgerIconTarget || !this.hasCloseIconTarget || !this.hasButtonTarget) {
      return
    }

    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
    
    // Ensure menu is hidden on page load
    this.menuTarget.classList.add("hidden")
    this.setButtonState(false)
  }

  toggle() {
    // Check if targets exist before operating
    if (!this.hasMenuTarget || !this.hasHamburgerIconTarget || !this.hasCloseIconTarget) {
      return
    }
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    // Check if targets exist before operating
    if (!this.hasMenuTarget || !this.hasHamburgerIconTarget || !this.hasCloseIconTarget) {
      return
    }
    
    this.menuTarget.classList.remove("hidden")
    this.setButtonState(true)
    
    // Add click outside listener
    this.clickOutsideHandler = this.handleClickOutside.bind(this)
    setTimeout(() => {
      document.addEventListener("click", this.clickOutsideHandler)
    }, 0)
  }

  close() {
    // Check if targets exist before operating
    if (!this.hasMenuTarget || !this.hasHamburgerIconTarget || !this.hasCloseIconTarget) {
      return
    }
    
    const restoreFocus = this.menuTarget.contains(document.activeElement)
    this.menuTarget.classList.add("hidden")
    this.setButtonState(false)
    
    // Remove click outside listener
    if (this.clickOutsideHandler) {
      document.removeEventListener("click", this.clickOutsideHandler)
      this.clickOutsideHandler = null
    }

    if (restoreFocus) this.buttonTarget.focus()
  }

  handleClickOutside(event) {
    // Close menu if clicking outside the navigation
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.menuTarget.classList.contains("hidden")) {
      event.preventDefault()
      this.close()
    }
  }

  setButtonState(open) {
    this.buttonTarget.setAttribute("aria-expanded", open.toString())
    this.buttonTarget.querySelector(".sr-only").textContent = open ? "Uždaryti meniu" : "Atidaryti meniu"
    this.setIconVisibility(this.hamburgerIconTarget, !open)
    this.setIconVisibility(this.closeIconTarget, open)
  }

  setIconVisibility(icon, visible) {
    icon.classList.toggle("scale-100", visible)
    icon.classList.toggle("opacity-100", visible)
    icon.classList.toggle("blur-0", visible)
    icon.classList.toggle("scale-[0.25]", !visible)
    icon.classList.toggle("opacity-0", !visible)
    icon.classList.toggle("blur-[4px]", !visible)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown)
    // Clean up event listener
    if (this.clickOutsideHandler) {
      document.removeEventListener("click", this.clickOutsideHandler)
      this.clickOutsideHandler = null
    }
  }
}
